import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './modules/home/containers/home-page/home-page.component';
import { ContactPageComponent } from './modules/contact/containers/contact-page/contact-page.component';
import { BlogPageComponent } from './modules/blog/containers/blog-page/blog-page.component';
import { AboutPageComponent } from './modules/about/containers/about-page/about-page.component';

const routes: Routes = [
  {
    path: '', component: HomePageComponent,
  },
  {
    path: 'games', component: BlogPageComponent
  },
  {
    path: 'apps', component: BlogPageComponent
  },
  {
    path: 'tutorials', component: BlogPageComponent
  },
  {
    path: 'blog', component: BlogPageComponent
  },
  {
    path: 'contact', component: ContactPageComponent
  },
  {
    path: 'about', component: AboutPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
